import pageLoading from './lib/pageLoading.js';
import modalImage from './lib/modalImage.js';
// import { isPage, isMobile } from "./lib/util";
// import scrollEffect from "./lib/scrollEffect.js";
// import observer from "./lib/observer.js";
// import gsap from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";
// import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import topValidation from 'top-validation';
import '@/scss/design.scss';

document.addEventListener('DOMContentLoaded', () => {
  pageLoading();
  modalImage();

  // お問い合わせ用バリデーション
  if (document.body.classList.contains('contact')) {
    topValidation();
  }
});

//------------ Serviceページ FAQスクリプト --------------
// FAQの質問をクリックすると回答が表示される
document.addEventListener('DOMContentLoaded', () => {
  // bodyタグに 'service' クラスがある場合のみ実行
  if (document.body.classList.contains('service')) {
    
    const faqQuestions = document.querySelectorAll('.faq_question');

    faqQuestions.forEach(question => {
      question.addEventListener('click', () => {
        const parent = question.parentNode;
        parent.classList.toggle('is-open');
      });
    });

    console.log('Serviceページ限定のFAQスクリプトを実行しました');
  }
});

//------------ ハンバーガーメニュー開閉 --------------//
document.addEventListener('DOMContentLoaded', () => {
  const menuBtn = document.querySelector('.menu_btn');
  const headerWrap = document.querySelector('.header_wrap');

  if (menuBtn && headerWrap) {
    menuBtn.addEventListener('click', () => {
      // クラスの付け外し
      menuBtn.classList.toggle('is-active');
      headerWrap.classList.toggle('is-open');

      // メニューが開いている時は背面をスクロールさせない
      if (headerWrap.classList.contains('is-open')) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    });

    // リンクをクリックしたらメニューを閉じる（ページ内リンク対策）
    const navLinks = document.querySelectorAll('.hd_nav_list a');
    navLinks.forEach(link => {
      link.addEventListener('click', () => {
        menuBtn.classList.remove('is-active');
        headerWrap.classList.remove('is-open');
        document.body.style.overflow = '';
      });
    });
  }
});

//------------ フロントページ　swiper --------------//
window.addEventListener('DOMContentLoaded', () => {
  const caseSwiperElem = document.querySelector('.case-swiper');
  
  if (caseSwiperElem) {
    const swiper = new Swiper('.case-swiper', {
      loop: true,
      spaceBetween: 50,
      slidesPerView: 1.2,
      // --- ゆっくり流すための設定 ---
      speed: 800, // 0.8秒かけて次のスライドへ（好みの速度に調整）
      autoplay: {
        delay: 3000, // 3秒待機してから次のスライドへ
        disableOnInteraction: false, // ユーザーが触っても止めない
      },
      breakpoints: {
        768: {
          slidesPerView: 2.2,
        },
        1024: {
          slidesPerView: 3.5,
        }
      }
    });
  }
});

